import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ProjectCostsPage } from '@/features/admin/usage/usage-page';
import { asPeriod, DEFAULT_PERIOD, type UsagePeriod } from '@/features/admin/usage/usage-model';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Coûts d'un projet (porting README #29) : `GET /costs?for=project&project=<id>`. */
export const Route = createFileRoute('/$tenant/projects/$projectId/costs')({
  validateSearch: (search: Record<string, unknown>): { period?: UsagePeriod } => {
    const period = asPeriod(search['period']);
    return period === DEFAULT_PERIOD ? {} : { period };
  },
  component: ProjectCostsRoute,
});

function ProjectCostsRoute() {
  const { tenant, projectId } = Route.useParams();
  const { period = DEFAULT_PERIOD } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      projectId={projectId}
      activeItem="usage"
      crumbs={[{ label: t('nav.items.usage') }, { label: t('admin.usage.projectCrumb') }]}
    >
      <ProjectCostsPage
        tenantId={tenant}
        projectId={projectId}
        period={period}
        onPeriodChange={(next) =>
          void navigate({ search: next === DEFAULT_PERIOD ? {} : { period: next }, replace: true })
        }
      />
    </ConsoleShell>
  );
}
